import { defineAsyncComponent } from 'vue'

export default {
    routes: [
        {
            path: '/lmail',
            name: 'lmail.index',
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'LMail',
                icon: 'fal fa-envelope-open-text fa-fw',
                permission: 'manage-lmail',
                menuItem: defineAsyncComponent(() => import('./components/MenuItem.vue')),
                auth: true,
                module: 'metatech/lmail',
            },
            children: [
                {
                    path: 'servers/:serverId',
                    name: 'lmail.server.show',
                    component: () => import('./views/server/Show.vue'),
                    meta: {
                        label: 'Server',
                        permission: 'manage-lmail',
                    },
                    children: [
                        {
                            path: 'aliases',
                            name: 'lmail.server.aliases.index',
                            component: () => import('./views/server/alias/Index.vue'),
                            meta: {
                                label: 'Aliases',
                                icon: 'fal fa-at fa-fw',
                                permission: 'manage-lmail',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: 'lmail.server.aliases.create',
                                    component: () => import('./views/server/alias/Index.vue'),
                                    meta: {
                                        label: 'Create Alias',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':aliasId/edit',
                                    name: 'lmail.server.aliases.edit',
                                    component: () => import('./views/server/alias/Index.vue'),
                                    meta: {
                                        label: 'Edit Alias',
                                        permission: 'manage-lmail',
                                    }
                                },
                            ]
                        },
                        {
                            path: 'domains',
                            name: 'lmail.server.domains.index',
                            component: () => import('./views/server/domain/Index.vue'),
                            meta: {
                                label: 'Domains',
                                icon: 'fal fa-globe fa-fw',
                                permission: 'manage-lmail',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: 'lmail.server.domains.create',
                                    component: () => import('./views/server/domain/Index.vue'),
                                    meta: {
                                        label: 'Create Domain',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':domainId/edit',
                                    name: 'lmail.server.domains.edit',
                                    component: () => import('./views/server/domain/Index.vue'),
                                    meta: {
                                        label: 'Edit Domain',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':domainId/aliases',
                                    name: 'lmail.server.domains.aliases',
                                    component: () => import('./views/server/domain/Index.vue'),
                                    meta: {
                                        label: 'Domain Aliases',
                                        permission: 'manage-lmail',
                                    },
                                    children: [
                                        {
                                            path: 'create',
                                            name: 'lmail.server.domains.aliases.create',
                                            component: () => import('./views/server/domain/Index.vue'),
                                            meta: {
                                                label: 'Create Alias',
                                                permission: 'manage-lmail',
                                            }
                                        },
                                        {
                                            path: ':aliasId/edit',
                                            name: 'lmail.server.domains.aliases.edit',
                                            component: () => import('./views/server/domain/Index.vue'),
                                            meta: {
                                                label: 'Edit Alias',
                                                permission: 'manage-lmail',
                                            }
                                        },
                                    ]
                                },
                                {
                                    path: ':domainId/mailboxes',
                                    name: 'lmail.server.domains.mailboxes',
                                    component: () => import('./views/server/domain/Index.vue'),
                                    meta: {
                                        label: 'Domain Mailboxes',
                                        permission: 'manage-lmail',
                                    },
                                    children: [
                                        {
                                            path: 'create',
                                            name: 'lmail.server.domains.mailboxes.create',
                                            component: () => import('./views/server/domain/Index.vue'),
                                            meta: {
                                                label: 'Create Mailbox',
                                                permission: 'manage-lmail',
                                            }
                                        },
                                        {
                                            path: ':aliasId/edit',
                                            name: 'lmail.server.domains.mailboxes.edit',
                                            component: () => import('./views/server/domain/Index.vue'),
                                            meta: {
                                                label: 'Edit Mailbox',
                                                permission: 'manage-lmail',
                                            }
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'logs',
                            name: 'lmail.server.logs.index',
                            component: () => import('./views/server/log/Index.vue'),
                            meta: {
                                label: 'Logs',
                                icon: 'fal fa-file-archive fa-fw',
                                permission: 'manage-lmail',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: 'lmail.server.logs.create',
                                    component: () => import('./views/server/log/Index.vue'),
                                    meta: {
                                        label: 'Create Gateway',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':logId/edit',
                                    name: 'lmail.server.logs.edit',
                                    component: () => import('./views/server/log/Index.vue'),
                                    meta: {
                                        label: 'Edit Gateway',
                                        permission: 'manage-lmail',
                                    }
                                },
                            ]
                        },
                        {
                            path: 'mailboxes',
                            name: 'lmail.server.mailboxes.index',
                            component: () => import('./views/server/mailbox/Index.vue'),
                            meta: {
                                label: 'Mailboxes',
                                icon: 'fal fa-mailbox fa-fw',
                                permission: 'manage-lmail',
                            },
                            children: [
                                {
                                    path: 'create',
                                    name: 'lmail.server.mailboxes.create',
                                    component: () => import('./views/server/mailbox/Index.vue'),
                                    meta: {
                                        label: 'Create Mailbox',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':mailboxId/edit',
                                    name: 'lmail.server.mailboxes.edit',
                                    component: () => import('./views/server/mailbox/Index.vue'),
                                    meta: {
                                        label: 'Edit Mailbox',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':mailboxId/aliases',
                                    name: 'lmail.server.mailboxes.aliases',
                                    component: () => import('./views/server/mailbox/Index.vue'),
                                    meta: {
                                        label: 'Mailbox Aliases',
                                        permission: 'manage-lmail',
                                    }
                                },
                                {
                                    path: ':mailboxId/reset-password',
                                    name: 'lmail.server.mailboxes.reset-password',
                                    component: () => import('./views/server/mailbox/Index.vue'),
                                    meta: {
                                        label: 'Reset Mailbox Password',
                                        permission: 'manage-lmail',
                                    }
                                },
                            ]
                        },
                    ]
                }
            ]
        }
    ]
}
